import React, { useState, useEffect, Suspense } from "react";
import "./RightNav.css";
import { useNavigate } from "react-router-dom";
import SvgWindowCloseIcon from "../icons/iconComponents/SvgWindowCloseIcon";
import { commitLocalUpdate } from "react-relay";
import { useTheme } from "../contexts/ThemeContext";
import { useMediaQuery } from "react-responsive";
import environment, { updateLocalSetting } from "../Environment";
import AnalysePageContainerTopWrapper from "../AnalysePageContainerTopWrapper";
import Spinner from "../Spinner";
import { ChevronRight24 } from "@carbon/icons-react";
// import { Maximize24 } from "@carbon/icons-react";
import Lorem from "../Lorem";
import Seperator from "./Seperator";
import CurrentAnalytics from "../CurrentAnalytics";

function RightNav(props) {
    const [isModalActive, setIsModalActive] = useState(false);
    const [isNavDisplayed, setIsNavDisplayed] = useState(false);
    const [isGlobal, setIsGlobal] = useState(false);
    const [isCurrent, setIsCurrent] = useState(true);
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery({
        query: "(max-device-width: 450px)",
    });

    const theme = useTheme();
    const { selectedAnayzeTitle, selectedAnalyzePostId } = props.settings;
    // console.log(selectedAnayzeTitle);
    // console.log(props.settings);

    useEffect(() => {
        setIsNavDisplayed(true);
    }, []);

    // const x = first_time_user ? 'first time user' : 'experienced user';

    function onWindowCloseClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isRightNavActivated");

            record.setValue("{}", "tagData");

            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "selectedLeads");
            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
        });
    }

    function onGlobalClick(e) {
        setIsGlobal(true);
        setIsCurrent(false);
    }

    function onCurrentClick(e) {
        setIsGlobal(false);
        setIsCurrent(true);
    }

    let navbarState = props.isActivated ? "open" : "closed";

    return (
        <div
            id="mySidebar"
            className={`right-sidebar theme-${theme.light} right-nav-${navbarState}`}
        >
            <div className={`right-nav-header theme-${theme.light}`}>
                <div
                    className={`right-nav-header-components theme-${theme.light}`}
                >
                    <ChevronRight24
                        className="right-close-icon"
                        onClick={onWindowCloseClick}
                    />
                    {/* <Maximize24 /> */}
                </div>
            </div>
            <div className={`right-nav-content theme-${theme.light}`}>
                <div className={`global-tab-container`}>
                    <span
                        className={`nav-link-button nav-link-button-${isCurrent}`}
                        onClick={onCurrentClick}
                    >
                        Current Article
                    </span>
                    <span
                        className={`nav-link-button nav-link-button-${isGlobal}`}
                        onClick={onGlobalClick}
                    >
                        Feed
                    </span>
                </div>
                <Seperator />
                {isGlobal ? (
                    <div>
                        {isNavDisplayed ? (
                            <AnalysePageContainerTopWrapper />
                        ) : null}
                    </div>
                ) : (
                    <div className={`gpt-container`}>
                        {isNavDisplayed ? (
                            <CurrentAnalytics
                                postId={selectedAnalyzePostId}
                                title={selectedAnayzeTitle}
                            />
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
}

export default RightNav;
